export const getIndicators = (state) => {
  return state.indicators.list;
}